import formatMoney from '../../utils/formatMoney'
import { getRefundBadge, getRefundDestination, getRefundInfo } from './refundInfo'

export const PILL_TONES = {
  emerald:
    'bg-emerald/10 text-emerald_deep ring-emerald/30 dark:bg-emerald-500/10 dark:text-emerald-400 dark:ring-emerald-400/30',
  amber:
    'bg-amber/[0.18] text-amber-700 ring-amber/40 dark:bg-amber-500/10 dark:text-amber-400 dark:ring-amber-400/30',
  coral:
    'bg-coral/[0.12] text-coral_deep ring-coral/30 dark:bg-red-500/10 dark:text-red-400 dark:ring-red-400/30',
  alert: 'bg-coral text-white ring-coral_deep/40 dark:bg-red-500/80 dark:ring-red-400/40',
  neutral:
    'bg-ink/[0.06] text-espresso ring-ink/10 dark:bg-dk-raised dark:text-gray-200 dark:ring-dk-border'
}

const pillClassName = ({ tone, wrap }) =>
  [
    'inline-flex items-center rounded-full px-2.5 py-1 text-xs font-bold tabular-nums ring-1',
    wrap ? null : 'whitespace-nowrap',
    PILL_TONES[tone] || PILL_TONES.neutral
  ]
    .filter(Boolean)
    .join(' ')

export function Pill({ tone = 'neutral', wrap = false, children }) {
  return <span className={pillClassName({ tone, wrap })}>{children}</span>
}

export default function RefundPill({ transaction, showAmount = true }) {
  const info = getRefundInfo(transaction)
  const badge = getRefundBadge(info)
  if (!badge) return null
  const amount = showAmount ? formatMoney(info.amount, info.currency) : null
  const destination = getRefundDestination(info)

  return (
    <span className='inline-flex flex-wrap items-center gap-x-2 gap-y-1' data-testid='refund-pill'>
      <Pill tone={badge.tone} wrap={badge.wrap}>
        {badge.label}
      </Pill>
      {amount && (
        <span className='text-xs font-semibold tabular-nums text-espresso dark:text-gray-200'>
          {amount}
        </span>
      )}
      {destination && (
        <span className='text-xs text-warm_gray dark:text-gray-400'>{destination}</span>
      )}
    </span>
  )
}

export { describeRefundReason, getRefundBadge, getRefundInfo, getRefundReason } from './refundInfo'
